export const LANG = {
    zn: 2052,
    en: 1033
}

const testKey = '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI';

export const SITEKEY = {
    HIGH:  "6LedIH8UAAAAAC4uGYgNVeilo2SIqriySTr0w-1d",
    LOW: "6LfxtYIUAAAAALdn2__RJYJHwwz25yTJiORxnbk2",
    // LOW: testKey,
}
